export const ReadyEnvironmentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99854 13.9974V7.99854"
      stroke="currentColor"
      strokeWidth="1.29975"
      strokeLinecap="round"
    />
    <path
      d="M7.99854 7.99951C7.99854 4.99951 10.4985 2.99951 12.9985 2.99951C12.4985 5.99951 10.4985 7.99951 7.99854 7.99951Z"
      stroke="currentColor"
      strokeWidth="1.29975"
      strokeLinejoin="round"
    />
    <path
      d="M7.99902 9.99878C7.99902 7.79878 5.99902 6.19878 3.99902 5.99878C4.29902 8.29878 5.79902 9.99878 7.99902 9.99878Z"
      stroke="currentColor"
      strokeWidth="1.29975"
      strokeLinejoin="round"
    />
  </svg>
);
